angular.module("listingOverviewModule").component("listingRentalContact", {
    templateUrl: "listingRentalContact/listingRentalContact.html",
    bindings: {
        listingName: '@',
        listingToken: '@',
        target: '<',
        user: '<',
        rpc: '@',
        isInlineForm: '@',
    },
    controller: ["$document", "$timeout", "$sce", "$element", "PubSub", function($document, $timeout, $sce, $element, PubSub) {
        var ctrl = this;
    
        ctrl.isInlineForm = ctrl.isInlineForm === 'true' || ctrl.isInlineForm === true;

        this.displayPartialPhone = () => {
            return this.target.phone.slice(0, this.target.phone.length - 4) + '<span class="phone-hidden">XXXX</span>';
        };
        
        this.openPopup = () => {
            let data = {
                isListing: true,
                buildingName: ctrl.listingName,
                listingToken: ctrl.listingToken,
                target: ctrl.target,
                user: ctrl.user,
                rpc: ctrl.rpc
            }
            console.log('publish', data);
            PubSub.publish('openContactV2NoFeePopup', data);
        }

    }]
});